import { render, staticRenderFns } from "./CreateReason.vue?vue&type=template&id=2c79176a"
import script from "./CreateReason.vue?vue&type=script&lang=js"
export * from "./CreateReason.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports